import { createWebHistory, createRouter } from "vue-router";

import Edition2023View from "@/views/Edition2023View.vue";
import Edition2024View from "@/views/Edition2024View.vue";
import Edition2025View from "@/views/Edition2025View.vue";
import Edition2026View from "@/views/Edition2026View.vue";

const routes = [
  { path: "/2023", name: "edition-2023", component: Edition2023View },
  { path: "/2024", name: "edition-2024", component: Edition2024View },
  { path: "/2025", name: "edition-2025", component: Edition2025View },
  { path: "/2026", redirect: "/" },
  { path: "/", name: "edition-2026", component: Edition2026View },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
